"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var EraserFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_EraserFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.504 13.166-7.67-7.67-1.3 1.3c-.375.375-.677.678-.902.943-.232.273-.41.539-.512.85a2.455 2.455 0 0 0 0 1.517c.101.311.28.577.512.85.225.265.527.568.902.942l2.568 2.568c.374.375.677.677.942.902.273.232.539.41.85.512.493.16 1.024.16 1.517 0 .311-.101.577-.28.85-.512.265-.225.568-.527.942-.902l1.3-1.3Z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.106.12a2.455 2.455 0 0 0-1.518 0c-.31.101-.577.28-.85.512-.265.225-.567.527-.941.902L2.83 5.5l7.67 7.67 3.966-3.967c.374-.374.677-.677.902-.942.232-.273.41-.539.511-.85.16-.493.16-1.024 0-1.517-.1-.311-.28-.577-.511-.85a17.363 17.363 0 0 0-.902-.942l-2.568-2.568a17.324 17.324 0 0 0-.942-.902c-.273-.232-.54-.41-.85-.512Z",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_EraserFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = EraserFill;
exports["default"] = _default;